
import React, { useState, useContext} from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import MenuItem from "./Submenu";

import PrivilegeContext from "../context/privilege";


import auth from "../../services/authService";
import Clock from "react-live-clock";


function Navbar(props) {
  const { user ,menelist   } = props;
  const {menuItems} = useContext(PrivilegeContext);
  const [click, setClick] = useState(false);
  const [load, setload] = useState(true);
  const [showsubmenu, setshowsubmenu] = useState([
    { statusid: false },
    { statusid: false },
    { statusid: false },
    { statusid: false },
    { statusid: false },
  ]);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = (event) => {
    setClick(false);
    if (event === "/login") {
      hide();
     
    }
  };
  const onMouseWhenEnter = (event) => {
    const id = event;
    const sublist = [...showsubmenu];
    if (window.innerWidth < 200) {
      sublist[id - 1].statusid = false;
    } else {
      sublist[id - 1].statusid = true;
    }
    setshowsubmenu(sublist);
  };
  const onMouseWhenLeave = (event) => {
    const id = event;
    if (id) {
      const sublist = [...showsubmenu];
      sublist[id - 1].statusid = false;
      if (window.innerWidth < 200) {
        setshowsubmenu(sublist);
      } else {
        setshowsubmenu(sublist);
      }
    }
  };

  const refreshPage = ()=>{
    window.location.reload();
 }

  const hide = (event) => {
    auth.logout();
    window.location = "/";
  };

  const onOpenItem = (event) => {
    const id = event;
    const sublist = [...showsubmenu];
    const found = sublist[id - 1].statusid;
    sublist[id - 1].statusid = !found;
    setshowsubmenu(sublist);
  };
  

  const firstClick = (id,idex) => {

   console.log(id,idex);
  

    if (id) {


    //   const sublist = [...showsubmenu];
    //   console.log('firstClick1',sublist[id - 1].statusid)
    //    if (window.innerWidth < 200) {
      
    //      sublist[id - 1].statusid = load;
    //      setload(!load)
    //  } 
       
    //    else {
    //     sublist[id - 1].statusid = true;
    //    }
    //   setshowsubmenu(sublist);
    }


 
  }



  return (
    <>
      <nav className="navbar-custom justify-content-between  ">
        <Link to="/" className="navbar-logo-custom" onClick={closeMobileMenu}>
          HRM
          <i className="fab fa-firstdraft ms-2" />
          {user && (
            <div className="d-none d-md-inline text-white text-muted">
              <img
                src={
                  "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=" +
                  user.empid +
                  "&size=320"
                }
                className="rounded-circle me-2 ms-4"
                data-toggle="tooltip"
                data-placement="bottom"
                title=""
                alt=""
                style={{
                  maxHeight: "50px",
                  Width: "100%",
                  maxWidth: "30px",
                }}
              ></img>
            </div>
          )}
          <strong
            className="d-none d-xl-inline ms-2 "
            style={{ fontSize: "14px" }}
          >
            <Clock format="ddd" ticking={true} interval={60000} />
          </strong>
          <strong
            className="d-none d-md-inline ms-2 "
            style={{ fontSize: "14px" }}
          >
            <Clock format="D MMM YYYY" ticking={true} interval={60000} />
          </strong>
          <strong
            className="d-none d-xl-inline ms-2 "
            style={{ fontSize: "14px" }}
          >
            <Clock format="HH:mm:ss" ticking={true} interval={1000} />
          </strong>
        </Link>

        {
          <div className="menu-icon-custom" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"} />
          </div>
        }

        <ul className={click ? "nav-menu-custom active" : "nav-menu-custom"}>
          {menuItems.map((menuItem, index) => { 
            // console.log('meItme', menuItems,index);
            // console.log('meItme2', menuItem.id);
          return (
            <li
              className="nav-item-custom"
              key={index}
              onMouseEnter={() => onMouseWhenEnter(menuItem.id)}
              onMouseLeave={() => onMouseWhenLeave(menuItem.id)}
              onClick={() => firstClick(menuItem.id,index)}
            >
              <div
                className="nav-links-custom"
                onClick={() => onOpenItem(menuItem.id)}
              >
                {menuItem.title} <i className="fas fa-caret-down" />
              </div>
              {showsubmenu &&
                showsubmenu[index].statusid &&
                menuItem.subMenus && (
                  <MenuItem
                    className={menuItem.iconClassName}
                    MenuItems={menuItem.subMenus}
                    onClick={closeMobileMenu}
                  ></MenuItem>
                )}
            </li>
          )})}
        </ul>
      </nav>
    </>
  );
}

export default Navbar;


// import React, { useState,useEffect,useContext } from 'react';
// import { Button } from './Button';
// import { Link } from 'react-router-dom';
// //import ConfirmLogout from './../common/confirmLogout';
// import './Navbar.css';
// import Dropdown from './Dropdown';
// import DropdownReport from './Dropdownreport';
// import DropdownService from './Dropdownservice';
// //import Dropdown1 from './Dropdown
// import auth from "../../services/authService";
// import PrivilegeContext from "../context/privilege";
// import Clock from 'react-live-clock';



// function Navbar(props) {
//   const { user} = props;
//   const privilegeContext = useContext(PrivilegeContext);
//   const [chkHR, setchkHR] = useState(false);
//   const [showreport, setshowreport] = useState(false);
//   const [showservice, setshowservice] = useState(false);
//   useEffect(() => {
//     const loadRegister = async () => {
//       try {
//         if (!privilegeContext.privilege) return;
//         if (privilegeContext.privilege.length ===18){
//          setchkHR(privilegeContext.privilege[17].chkEnable)
//         }
       
//       } catch (ex) {
       
//       }
//     };
//     loadRegister();
//   }, [privilegeContext.privilege]);
  
//   const [click, setClick] = useState(false);
//   const [dropdown, setDropdown] = useState(false);
  
//   // const [collapsed ,setcollapsed] = useState(true) ;
//   //const [isModalLogoutOpen ,setisModalLogoutOpen] = useState(false) ;
//  // const hide = () => setcollapsed(true);

//   const handleClick = () => setClick(!click);
//   const closeMobileMenu = () => setClick(false);

//   const onMouseEnter = () => {
//     if (window.innerWidth < 200) {
//       setDropdown(false);
//     } else {

     
//       setDropdown(true);
//     }
//   };
//    const onMouseServiceEnter = () => {
//     if (window.innerWidth < 200) {
//       setshowservice(false);
//     } else {
//       setshowservice(true);
//     }
//   };
//   const onMouseReportEnter = () => {
//     if (window.innerWidth < 200) {
//       setshowreport(false);
//     } else {
//       setshowreport(true);
//     }
//   };
//   const openitem = () => {

//    // console.log('you click')
//    setDropdown(!dropdown);
//     //setDropdown(!dropdown);
//   }
//   const onOpenReportItem = () => {
//     setshowreport(!showreport);
//   }

//   const onOpenServicetItem = () => {
//     setshowservice(!showservice);
//   }
//   const onMouseLeave = () => {
//   //  console.log("mouse leave")
//     if (window.innerWidth < 200) {
//       setDropdown(false);
//     } else {
//       setDropdown(false);
//     }
//   };
//   const onMouseReportLeave = () => {
//     if (window.innerWidth < 200) {
//       setshowreport(false);
//     } else {
//       setshowreport(false);
//     }
//   };

//   const onMouseServiceLeave = () => {
//     if (window.innerWidth < 200) {
//       setshowservice(false);
//     } else {
//       setshowservice(false);
//     }
//   };

//   //   const onMouseLeave2 = () => {
//   //   if (window.innerWidth < 200) {
//   //     setDropdown2(false);
//   //   } else {
//   //     setDropdown2(false);
//   //   }
//   // };

//   const hide = (event) => {
//    // console.log('you click',event)
//         auth.logout();
//       window.location = "/";
//   }

// //   const onLogoutConfirm = () => {
// //     setisModalLogoutOpen(false); 
// // }

// // const onLogoutCancel =() => {
// //   setisModalLogoutOpen(false); 
// // }
// //console.log(showreport)
//  // console.log('Navbar =',user);
//   return (
//     <>
     
//       <nav className="navbar-custom justify-content-between  ">
//         <Link to="/" className="navbar-logo-custom " onClick={closeMobileMenu}>
//           HRM
//           <i className="fab fa-firstdraft" />

//           {user &&           
// <div className="d-none d-md-inline text-white text-muted">
//                               <img
//                                 src={"https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=" + user.empid + "&size=320"}
//                                 className="rounded-circle me-2 ms-4"
//                                 data-toggle="tooltip"
//                                 data-placement="bottom"
//                                 title=""
//                                 alt=""
//                                 style={{
//                                   maxHeight: "50px",
//                                   Width: "100%",
//                                   maxWidth: "30px",
//                                 }}
//                               ></img>


//                    </div>   
                   

//           }
//              <strong className="d-none d-xl-inline ms-2 " style={{ fontSize: "14px" }}><Clock format="ddd" ticking={true} interval={60000} /></strong>
//             <strong className="d-none d-md-inline ms-2 " style={{ fontSize: "14px" }}>
//               <Clock format="D MMM YYYY" ticking={true} interval={60000} />
//             </strong>
//             <strong className="d-none d-md-inline ms-2 " style={{ fontSize: "14px" }}><Clock format="HH:mm:ss" ticking={true} interval={1000} /></strong>
//         </Link>


//         {/* {user && <div className="navbar-time" >
//             <strong className="d-none d-xl-inline ms-2"><Clock format="ddd" ticking={true} interval={60000} /></strong>
//             <strong className="d-none d-md-inline ms-2">
//               <Clock format="D MMMM YYYY" ticking={true} interval={60000} />
//             </strong>
//             <strong className="d-none d-md-inline ms-2"><Clock format="HH:mm:ss" ticking={true} interval={1000} /></strong>
//           </div>} */}

//         { <div className="menu-icon-custom" onClick={handleClick}>
//           <i className={click ? "fas fa-times" : "fas fa-bars"} />
//         </div>}
//         <ul className={click ? "nav-menu-custom active" : "nav-menu-custom"}>

//           { user && <li className="nav-item-custom"
//           onMouseEnter={onMouseServiceEnter}
//           onMouseLeave={onMouseServiceLeave}
//           >
//             <Link
//               to="/faceinout"
//               className="nav-links-custom"
//               onClick={onOpenServicetItem}
//             >
//               งานบริการ
//             </Link>
//             {showservice && 
//             <DropdownService
//             onClick = {closeMobileMenu}
//             >
              
//             </DropdownService>
//            }
//           </li>}
//           { user  && <li
//             className="nav-item-custom"
//             onMouseEnter={onMouseEnter}
//             onMouseLeave={onMouseLeave}
//           >
//             <Link        
//               className="nav-links-custom"
//               onClick = {openitem}
//               to="/search"
//             >
//               FaceManage <i className="fas fa-caret-down" />
//             </Link>
//             {dropdown && 
//             <Dropdown
//             onClick = {closeMobileMenu}
//             >
              
//             </Dropdown>
//            }
//           </li>}

//           { user && <li
//             className="nav-item-custom"
//             onMouseEnter={onMouseReportEnter}
//             onMouseLeave={onMouseReportLeave}
//           >
//             <Link
//               to =""
//               className="nav-links-custom"
//               onClick={onOpenReportItem}
//             >
//               รายงาน
//               <i className="fas fa-caret-down" />
//             </Link>
//             {showreport && <DropdownReport
//              onClick = {closeMobileMenu} 
//              />}
//           </li>}

//           {/* { user && <li
//             className="nav-item"
//             onMouseEnter={onMouseEnter2}
//             onMouseLeave={onMouseLeave2}
//           >
//             <Link
//               to="/smartphone"
//               className="nav-links"
//               onClick={closeMobileMenu}
//             >
//               Smart Phone
//               <i className="fas fa-caret-down" />
//             </Link>
//             {dropdown2 && <Dropdown1 />}
//           </li>} */}
          
//           {/* { user && <li className="nav-item">
//             <Link
//               to="/registernotebook"
//               className="nav-links"
//               onClick={closeMobileMenu}
//             >
//               Notebook
//             </Link>
//           </li>} */}

//           {/* { user && <li className="nav-item">
//             <Link
//               className="btn btn-outline-success my-2 my-sm-0"
//               to="/registeroffice"
//               className="nav-links"
//               onClick={closeMobileMenu}
//             >
//               Office
//             </Link>
//           </li>} */}
//           {user ? <li>
//             <Link
//               to="logout"
//               className="nav-links-mobile"
//               onClick={hide}
//                >
//               Sign Out
//             </Link>
//             </li> : <li>
//             <Link
//               to="login"
//               className="nav-links-mobile"
//                >
//               Sign In
//             </Link>
//             </li>}


//           {/* <li className="nav-item">
//             <Link to="logout">
//               <div>
//                 <button className="btn-custom mb-4">Sign Out</button>
//               </div>
//             </Link>
//           </li> */}
//         </ul>



//        <Button 
//        user ={user}
//        onClick={hide}
//        >

//        </Button>

       
//       </nav>
//     </>
//   );
// }

// export default Navbar;
